import { BaseAnnotation } from '../base_annotation';

let DEFINITIONS = {}; 

export class DefinitionProvider extends BaseAnnotation {
    constructor(props) {
        super(props)
        this.fetchedDefinitionFiles = {};
    }

    componentDidMount() {
        this.fetchDefinitionFile(this.props.content)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.content !== this.props.content && !this.fetchedDefinitionFiles[this.props.content]) {
            this.fetchDefinitionFile(this.props.content)
        }
    } 

    fetchDefinitionFile = arb => {
        if (!arb) {
            return; 
        }

        this.fetchedDefinitionFiles[arb] = 'loading';

        fetch(arb)
            .then(res => {
                if (!res.ok || res.status >= 400) {
                    const errorMessage = `${res.status} definition file not resolved, no definitions available`;
                    throw new Error(errorMessage);
                }

                return res;
            })
            .then(res => res.json())
            .then(res => {
                Object.keys(res).forEach(key => DEFINITIONS[key] = res[key]);
                this.fetchedDefinitionFiles[arb] = res;
            })
            .catch(err => console.warn(err));
    }
}

export const getDefinition = word => DEFINITIONS[word.toLowerCase()] || 'No Definition';